import { WeatherIconComponent } from '../Icon/WheaterIconComponent';
import type { WeatherReport } from '../api/internal-api-types';

import styles from './DayForecast.module.scss';
import { ForecastSection } from './ForecastSection';
import { WeatherValue } from './WeatherValue';
type Props = {
	forecast: WeatherReport['days'][number];
	className?: string;
};

export function DayForecast({ forecast: { date, sections }, className = '' }: Props) {
	return (
		<ForecastSection
			title={
				<>
					Tagesvorhersage: <time dateTime={date.timestamp}>{date.humanReadable}</time>
				</>
			}
			className={`${className} body5`}
		>
			{sections.map(({ time, temp, icon }) => {
				return (
					<div className={styles.hourForecast} key={time.timestamp}>
						<div className="heading1">
							<WeatherValue {...temp} separator="" />
						</div>
						<time dateTime={time.timestamp}>{time.humanReadable}</time>
						{icon ? <WeatherIconComponent name={icon} className={styles.icon} /> : null}
					</div>
				);
			})}
		</ForecastSection>
	);
}
